<template>
    <list-page-shell title="公示中">
        <order-workbench
            :show-title="false"
            :show-announcement-columns="true"
            :hide-primary-actions="true"
            :auto-column-width="true"
            :extra-query-params="{ publicity_list: 1 }"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'PublicityList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/PublicityList.vue